import { useCallback, useEffect, useState} from 'react';
import {
  AppBar,
  Box,
  Button,
  Grid,
  Hidden,
  IconButton,
  makeStyles,
  Toolbar,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { useHistory, useLocation } from "react-router-dom";
import UtilService from '../../../../helper/service';
import { useDispatch, useSelector } from 'react-redux';
import {
  getHashCode,
  getSessionParticipants,
  updateIdentifiers,
  updateSessionData
} from "../../../../store/actions/creator/creatorExperienceManager";
import ImmersionModal from '../../modals/commonModal';
import {
  completeExperience,
  getIdentifiersCallback,
  getSegmentAsClip,
  initAnalysisData,
  onGetClipInfo,
  saveCurrentSession,
  updateAnalyzeClipedData,
  updateClipedData,
  updateSettings
} from '../../../../store/actions/creator/analysis';
import RightScoreSectionAsync from './experienceManagerAsyncSection';
import RightScoreSectionReels from './experienceManagerReelsSection';
import axios from 'axios';
import ExperienceManagerModScore from './experienceManagerModScore';
import { getProjects } from "../../../../store/actions/creator/creatorDashboard";
import clsx from 'clsx';
import Config from "../../../../config/config";
import roles from "../../../../helper/roles";
import AnalyzeTopTabs from '../../creator/analyzeTopTabs';
import DashboardHeaderSearchBox from '../../creator/dashboardHeaderSearchBox';
import AnalyzeBreadcrumb from '../../creator/analyzeBreadcrumb';
import { updateMergeButtonStatus, updateSearchKey } from '../../../../store/actions/experience/experience';
import IMAGES from '../../../../config/images';
import TrialBanner from './trialBanner';
import { getBillingDetails, setTrailheader } from "../../../../store/actions/admin/user";
import { Skeleton } from '@material-ui/lab';
import { startParticipantListCreate } from "../../../../store/actions";
import { onStartAddParticipants } from "../../../../store/actions/participant/list";

const MQTT = require('async-mqtt');

const useStyles = makeStyles((theme) => ({
  toolbar: {
    minHeight: 64
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    color: '#111',
    marginLeft: 80,
    [theme.breakpoints.down('sm')]: {
      fontSize: 17,
      marginLeft: 30,
    }
  },
  pdfLeft: {
    marginLeft: -80,
    [theme.breakpoints.down('sm')]: {
      marginLeft: -30,
    }
  },
  imgDiamond: {
    width: 11,
    height: 11,
    position: 'absolute',
    marginTop: 6,
  },
  dFlex: {
    display: 'flex'
  },
  stopBtn: {
    height: 37,
    borderRadius: 6,
    background: '#D34A40',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#D35A4A',
    },
    margin: '0 21px',
  },
  timeBox: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 12,
    '@media (max-width: 600px)': {
      position: 'absolute',
      bottom: 7,
      left: 150
    },
  },
  rec: {
    height: 38,
    background: '#8192A2',
    color: '#FFFFFF',
    fontSize: 14,
    fontFamily: 'Spartan-regular',
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 10px!important',
  },
  time: {
    marginLeft: 2,
    fontFamily: 'Spartan-bold',
    fontSize: 24,
    marginTop: 2.5,
    width: 130,
  },
  recTime: {
    width: 50,
    display: 'flex',
    justifyContent: 'center',
  },
  mobileHeaderLogo: {
    width: 40,
    height: 40,
    '@media only screen and (max-width: 340px)': {
      width: 30,
      height: 30
    },
  },
  codeLabel: {
    fontSize: '14px',
    fontFamily: 'Spartan-bold',
    color: '#212D40',
    textTransform: 'uppercase',
    marginTop: '4px'
  },
  topTitle: {
    fontSize: '30px',
    fontFamily: 'Spartan-bold',
    letterSpacing: '0!important',
    color: 'rgba(33, 45, 64, 1)',
    marginLeft: '80px!important',
    marginTop: '8px',
    minWidth: '210px',
    marginBottom: '8px',
    '@media only screen and (max-width: 959px)': {
      marginLeft: '0!important'
    },
    '@media only screen and (max-width: 786px)': {
      marginLeft: '10px!important',
      display: 'inline-block',
      whiteSpace: 'nowrap'
    },
    '@media only screen and (max-width: 600px)': {
      minWidth: 190,
      fontSize: 18,
    },
    '@media only screen and (max-width: 400px)': {
      minWidth: 170,
      fontSize: 18,
    },
  },
  ellipsis: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    '@media only screen and (max-width: 600px)': {
      width: 190,
      fontSize: 18,
      marginTop: 3,
      overflow: 'hidden!important',
      textOverflow: 'ellipsis',
    },
    '@media only screen and (max-width: 400px)': {
      width: 150,
    }
  },
  buttonWrapper: {
    textAlign: 'right',
    '@media (min-width: 1280px)': {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  },
  btn: {
    height: 37,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    margin: '0 15px',
  },
  addNewBtn: {
    fontFamily: 'roboto-regular',
    marginLeft: 5,
    marginRight: 5,
    marginTop: 3,
    whiteSpace: 'nowrap',
    '@media (max-width: 840px)': {
      display: 'none'
    },
  },
  menuLogo: {
    width: 50,
    height: 50,
    '@media (max-width: 600px)': {
      width: 30,
      height: 30,
      marginLeft: -18,
      marginRight: -12
    },
  }
}));

function TopBar(props: any) {
  let myInterval: any;
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation<any>();
  const { onMobileNavOpen, className } = props;
  const participants = useSelector((state: any) => state.experience.participants);
  const { userMetrics } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { addParticipantList } = userMetrics;
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [open, setOpen] = useState(false);
  const { currentSession, cliped, settings, stimulus } = useSelector((state: any) => state.analysis);
  const { pdfLoading } = settings;
  const [timer, setTimer] = useState('00:00:00');
  const { started_at, session_id, session_status, session_title, session_type, scheduled_end_at, ended_at, session_code, large_thumbnail } =
    currentSession ? currentSession : participants.session;
  const [initSession, setInitSession] = useState(false);
  const [currentSessionCode, setCurrentSessionCode] = useState(localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "");
  const { searchKey } = useSelector((state: any) => state.experience);
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down('xs'));

  let daysLeft = 0;
  const { billingDetails, trailheader } = useSelector((state: any) => state.adminUser);

  useEffect(() => {
    if (location.pathname.includes('/creator/experience-manager/') && !location.pathname.includes('/creator/experience-manager/invite') && session_code) {
      dispatch(getHashCode(apolloClient.client, session_code, (res: any) => {
        if (res) {
          window.location.hash = res
        }
      }));
    }
  }, [session_code]);

  useEffect(() => {
    if (location.pathname.includes('/creator/experience-manager/') && stimulus && !stimulus?.play_url) {
      const cleanedURL = (stimulus && stimulus.stimulus_link) && stimulus.stimulus_link.replace('app=desktop&', '')
      const baseUrl = UtilService.checkYoutubeVimeoURL((stimulus && stimulus.stimulus_link) ? stimulus.stimulus_link : '');
      baseUrl && axios.get(`${baseUrl}${cleanedURL}&format=json`)
        .then(() => {
          dispatch(updateSettings('videoRemoved', false));
        })
        .catch(() => {
          dispatch(updateSettings('videoRemoved', true));
        })
    }
  }, [stimulus])

  useEffect(() => {
    const request = { username: loginUserData.username };
    if (location.pathname.includes('/creator/dashboard') ||
      location.pathname.includes('/overview') ||
      location.pathname.includes('/participants') ||
      location.pathname.includes('/analyze') ||
      location.pathname.includes('/compare') ||
      location.pathname.includes('/user/profile')) {
      dispatch(getBillingDetails(apolloClient.client, request));
    }
  }, [apolloClient.client, dispatch, loginUserData.user_id])

  useEffect(() => {
    if (!!loginUserData && loginUserData.user_id) {
      const request1 = { projectOwnerId: Number(loginUserData.user_id) };
      if (location.pathname.includes('/creator/dashboard')) {
        dispatch(getProjects(apolloClient.client, request1));
      }
    }
  }, [apolloClient.client, dispatch, loginUserData.user_id]);

  useEffect(() => {
    const MQTTConnect = async () => {
      let client: any = null;
      let endpoint = await UtilService.mqttEndpoint();
      client = await MQTT.connectAsync(endpoint, {
        transformWsUrl: () => {
          UtilService.mqttEndpoint().then(
            result => { endpoint = result },
            error => alert(error) // doesn't run
          );
          return endpoint;
        }
      });
      // setIsConnected(true);
      client.on('message', (topic: any, message: any) => {
        if (topic.split(":")[0] === "activity") {
          handleSessionStatus(JSON.parse(message));
        }
      });
      try {
        const topic = `activity:${Config.ENV}/v2/session/status/${currentSessionCode}`;
        await client.subscribe(topic, () => { });
      } catch (err) { }
    };
    MQTTConnect();

    if (location.pathname.includes('/creator/experience-manager')) {
      setTimeout(() => {
        const clipedData = JSON.parse(localStorage.getItem("cliped") || '{}');
        if (clipedData?.session_code && currentSessionCode === clipedData?.session_code) {
          dispatch(updateClipedData(clipedData))
        }
      }, 2000);
      const splits = location.pathname.split('/');
      if (splits && splits.length > 0) {
        const sessionCode = splits[splits.length - 1];
        setCurrentSessionCode(sessionCode);
        if (sessionCode) {
          const request = { session_code: sessionCode }
          dispatch(getIdentifiersCallback(apolloClient.client, sessionCode, session_type === 'MODERATED', (res: any) => {
            dispatch(updateIdentifiers(res));
          }));

          dispatch(getSessionParticipants(apolloClient.client, request, (res: any) => {
            if (res && res.session) {
              dispatch(updateSessionData(res));
              dispatch(saveCurrentSession(res.session))
            } else if (res && res === 'INSUFFICIENT_PERMISSIONS') {
              checkAndGoCreatorDashboard();
            }
          }));
        }
      }
    }
  }, []);

  const getPassedTime = () => {
    myInterval = setInterval(() => {

      const nowTime = new Date().getTime();
      const now_10 = Number(nowTime.toString().slice(0, 10));
      const unit = now_10 - Number(started_at) - 10;
      const timer = UtilService.convertSecondsToHHMMSS(unit); // 10s behind

      if (now_10 >= Number(scheduled_end_at) && !ended_at) {
        clearInterval(myInterval)
      } else {
        unit > 0 && setTimer(timer);
      }
    }, 1000);
  };

  useEffect(() => {
    if (session_status === 'LIVE' && location.pathname.includes('/creator/experience-manager/')) {
      getPassedTime();
    }
  }, [scheduled_end_at]);

  // useEffect(() => {
  //   function getCheckStatus() {
  //     if (session_code && location.pathname.includes('/creator/experience-manager/') && session_status === 'LIVE') {
  //
  //       const nowTime = new Date().getTime();
  //       const now_10 = Number(nowTime.toString().slice(0, 10));
  //
  //       if (now_10 >= Number(scheduled_end_at) && !ended_at) {
  //         handleCompleteSession(true)
  //       }
  //     }
  //   }
  //
  //   const interval = setInterval(() => getCheckStatus(), 10000)
  //   return () => {
  //     clearInterval(interval);
  //   }
  // }, [session_status, session_code])

  useEffect(() => {
    if (!location.pathname.includes('creator/dashboard') && searchKey) {
      dispatch(updateSearchKey(''));
    }
    if (location.pathname.includes('/creator/experience-manager/compare')) {
      dispatch(updateMergeButtonStatus(false));
    } else {
      dispatch(updateMergeButtonStatus(true));
    }
  }, [location.pathname]);

  useEffect(() => {

    if (session_code && stimulus && session_type === 'ASYNC') {
      dispatch(getSegmentAsClip(loginUserData.customer_id, stimulus.stimulus_id))
    }
    if (session_code && session_type === 'MODERATED') {
      dispatch(getSegmentAsClip(loginUserData.customer_id, session_code))
    }
    if (cliped !== null && currentSession) {

      onGetClipBreakUp();

    } else {
      dispatch(updateAnalyzeClipedData([]))
    }

  }, [session_code, stimulus?.stimulus_id, cliped]);

  const onGetClipBreakUp = async () => {
    const params = {
      tenant_id: loginUserData.customer_id,
      clip_id: cliped.clip_id,
      session_code: cliped.session_code
    }

    const requestBody = {
      name: cliped.title,
      length: cliped.length,
      immersion: cliped.score.immersion.immersion_index,
      immersion_tier_indicator: cliped.score.immersion.tier_indicator,
      immersion_color_indicator: cliped.score.immersion.color_indicator,
      immersion_context_indicator: cliped.score.immersion.context_indicator,
      safety: cliped.score.safety.safety_index,
      safety_tier_indicator: cliped.score.safety.tier_indicator,
      safety_color_indicator: cliped.score.safety.color_indicator,
      safety_context_indicator: cliped.score.safety.context_indicator,
      session_code: cliped.session_code,
      session_status: cliped.session_status,
      session_title: session_title,
      session_type: cliped.session_type,
      img: large_thumbnail,
      start: cliped.start_clip,
      end: cliped.end_clip,
      session_id: "clip-" + cliped.clip_id,
      clip_id: "clip-" + cliped.clip_id
    }

    dispatch(onGetClipInfo(params, (res: any) => {
      if (res && res.data?.category_breakup) {
        const breakup = res.data?.category_breakup;
        const immersion_detail = {
          Captivated: breakup.immersion_breakup[0].category_percent,
          Absorbed: breakup.immersion_breakup[1].category_percent,
          Interested: breakup.immersion_breakup[2].category_percent,
          Indifferent: breakup.immersion_breakup[3].category_percent,
          "Tuned Out": breakup.immersion_breakup[4].category_percent,
        }

        const safety_detail = {
          Zen: breakup.safety_breakup[0].category_percent,
          'Very Safe': breakup.safety_breakup[1].category_percent,
          Safe: breakup.safety_breakup[2].category_percent,
          Unsafe: breakup.safety_breakup[3].category_percent,
          'Very Unsafe': breakup.safety_breakup[4].category_percent,
        }

        dispatch(updateAnalyzeClipedData([{ ...requestBody, immersion_detail, safety_detail }]))

      } else {
        dispatch(updateAnalyzeClipedData([requestBody]))
      }
    }));
  }

  const handleSessionStatus = (message: any) => {

    const mqtt_activity_type = message['session_activity'].activity_type;
    const mqtt_session_code = message['session_activity'].session_code;
    const mqtt_session_status = message['session_activity'].session_status;

    const isCorrectSession = window.location.pathname.includes(mqtt_session_code);
    isCorrectSession && dispatch(updateSettings('mqttStatus', mqtt_session_status));

    if (mqtt_session_status === "IMMERSION_PROCESSED_COMPLETED" && isCorrectSession) {
      dispatch(updateSettings('mqttBackendCalcTime', new Date()));
    }

    if (mqtt_activity_type === 'session' && isCorrectSession) {

      if (mqtt_session_status === 'COMPLETED') {
        !initSession && dispatch(initAnalysisData('liveToCompleted'));
      }
      if (
        mqtt_session_status === 'LIVE' ||
        mqtt_session_status === 'IMMERSION_PROCESSED_LIVE' ||
        mqtt_session_status === 'COMPLETED' // we have to put this code if we need to get the updated status and get data for the session
      ) {

        mqtt_session_status === 'LIVE' && dispatch(initAnalysisData(true));
        // !initSession && mqtt_session_status === 'IMMERSION_PROCESSED_LIVE' && dispatch(initAnalysisData('liveToCompleted'));

        // setTimeout(() => {
        //   dispatch(getSessionParticipants(apolloClient.client, request, (res: any) => {
        //     if (res && res.session) {
        //       dispatch(updateSessionData(res));
        //       dispatch(saveCurrentSession(res.session))
        //       setInitSession(false);
        //     }
        //   }));
        // }, 3000)
      }
      const request = { session_code: mqtt_session_code };
      setTimeout(() => {
        dispatch(getSessionParticipants(apolloClient.client, request, (res: any) => {
          if (res && res.session) {
            dispatch(updateSessionData(res));
            dispatch(saveCurrentSession(res.session));
            setInitSession(false);
          }
        }));
      }, 3000)
    }
  };

  const checkAndGoCreatorDashboard = () => {
    let url = '/creator/dashboard';
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
    if (!!userData) {
      const creator_dashboard = userData.role_access.filter((val: any) => val.access_name === "creator_dashboard");
      if (creator_dashboard.length > 0 && creator_dashboard[0].access_value) {
        url = "/creator/dashboard"
      }
      if (UtilService.checkTrialAccess(userData, roles['trial']['dashboard'])) {
        url = "/subscriber/creator/dashboard";
      }
    }
    history.push(url);
  };

  const handleCompleteSession = (autoComplete?: any) => {
    dispatch(updateSettings('mqttStatus', 'COMPLETED'))

    setOpen(false);
    dispatch(initAnalysisData('liveToCompleted'));
    setInitSession(true);

    const request = {
      user_id: loginUserData.user_id,
      session_id
    };
    dispatch(completeExperience(apolloClient.client, request, () => { }));

    autoComplete && setTimeout(() => {
      dispatch(getSessionParticipants(apolloClient.client, { session_code: currentSessionCode }, (c: any) => {
        if (c && c.session) {
          dispatch(updateSessionData(c));
          dispatch(saveCurrentSession(c.session))
        }
      }));
    }, 10000);
  };

  const isClipAvailable = () => {
    return (location.pathname.includes('/analyze') || location.pathname.includes('/compare') || location.pathname.includes('/overview'));
  };

  const displayTrialBanner = () => {
    if (billingDetails) {
      if (location.pathname.includes('/creator/dashboard') ||
        location.pathname.includes('/overview') ||
        location.pathname.includes('/participants') ||
        location.pathname.includes('/analyze') ||
        location.pathname.includes('/compare') ||
        location.pathname.includes('/user/profile')) {

        if (billingDetails.data && billingDetails.data.enterprise_billing == false && billingDetails.data.department_name == loginUserData.username && billingDetails.data.pay_status == 'TRIAL') {
          const temp_trial_period = UtilService.calculateTrialDays(billingDetails.data.pay_started_at);
          const trial_period = billingDetails.data.billing_period - temp_trial_period;
          if (trial_period < 0) {
            daysLeft = 0;
          } else {
            daysLeft = trial_period
          }
          if (trailheader !== true) {
            trailheaderAction(true)
          }
          return true
        }
      } else {
        if (trailheader !== false) {
          trailheaderAction(false)
        }
        return false
      }
    }
  }

  const trailheaderAction = (value: boolean) => {
    dispatch(setTrailheader(value))
  };

  const onCreateNewList = () => {
    dispatch(startParticipantListCreate(true));
  };

  const onAddParticipants = () => {
    dispatch(onStartAddParticipants(true));
  };

  const isEditable = useCallback(() => {
    const editable = localStorage.getItem('listEditable') ? localStorage.getItem('listEditable') : '';
    return editable === 'true';
  }, [localStorage]);

  const children = <IconButton onClick={onMobileNavOpen}>
    <img onClick={onMobileNavOpen} src={IMAGES.logo} alt={'logo'} className={classes.menuLogo} />
  </IconButton>

  return (
    <AppBar className={className} id='topbar'>
      {displayTrialBanner() &&
        <TrialBanner daysLeft={daysLeft} billingDetails={billingDetails.data} />
      }
      <Toolbar className={classes.toolbar} >
        <Hidden {...{ mdUp: true, children }} />

        {(isMobileDevice && location.pathname.includes('/creator/dashboard')) ? (
          <>
            <p className='mobile-topbar-title'>My Experiences</p>
            {
              location.pathname.includes('/creator/dashboard') &&
              <DashboardHeaderSearchBox />
            }
          </>
        ) : (
          <>
            <div className={pdfLoading && classes.pdfLeft}>
              {!isMobileDevice && <AnalyzeBreadcrumb />}
              {(location.pathname.includes('/creator/experience-manager') && !addParticipantList) && (
                <div className={clsx(classes.topTitle, classes.dFlex)}>
                  {currentSession
                    ? ((cliped && isClipAvailable())
                      ? (cliped.title
                        ? <div>
                          <span className={classes.ellipsis}>{cliped.title}</span>
                          <div className={classes.codeLabel}>
                            {`EXP ID#: ${session_code}`}
                          </div>
                        </div>
                        : 'Clip')
                      : (session_title
                        ? (
                          <div>
                            <span className={classes.ellipsis}>{session_title}</span>
                            <div className={classes.codeLabel}>
                              {`EXP ID#: ${session_code}`}
                            </div>
                          </div>
                        )
                        : <Skeleton height={50} width={200} />
                      ))
                    : <Skeleton height={50} width={200} />}

                  {location.pathname.includes('/creator/experience-manager/compare') && (
                    <div style={{ marginLeft: 12 }}>
                      <img className={clsx(classes.imgDiamond)} src={'/assets/icons/compare/icon_diamond.svg'} alt={'img'} />
                    </div>
                  )}
                </div>
              )}
              {(!location.pathname.includes('/creator/experience-manager') || location.pathname.includes('/creator/experience-manager/invite')) && (
                ((location.pathname.includes('/experience-builder') || location.pathname.includes('/creator/experience-manager/invite')) && addParticipantList) ? (
                  <p className='topbar-page-title'>My Participant Lists</p>
                ) : (
                  <p className='topbar-page-title'>{UtilService.getTitle(location.pathname)}</p>
                )
              )}
            </div>

            <Box ml={2} flexGrow={1} />
            {
              (location.pathname.includes('/experience-manager/analyze') && session_type !== 'ASYNC' && session_status === 'LIVE') && !isMobileDevice &&
              <div className={classes.timeBox}>
                <Button className={classes.stopBtn} onClick={() => setOpen(true)}>
                  <img src={'/assets/icons/liveanalysis/stop.svg'} alt={'img'} />
                  <span style={{ marginLeft: 5, marginRight: 5 }}>Stop</span>
                </Button>
                <div className={classes.rec}>
                  <div className={classes.recTime}>
                    <img src={'/assets/icons/liveanalysis/rec-icon.svg'} alt={'img'} />&nbsp;
                    <div style={{ marginTop: 2 }}>REC</div>&nbsp;&nbsp;
                  </div>
                  <div className={classes.time}>
                    <span>{timer}</span>
                  </div>
                </div>
              </div>
            }
            {
              (location.pathname.includes('/creator/experience-manager') && !addParticipantList && session_type === 'MODERATED') &&
              <ExperienceManagerModScore pathname={location.pathname} isMobile={isMobileDevice} onStop={() => setOpen(true)} timer={timer} />
            }

            {
              (location.pathname.includes('/creator/experience-manager') && !addParticipantList && session_type === 'ASYNC') &&
              <RightScoreSectionAsync pathname={location.pathname} isMobile={isMobileDevice} />
            }
            {
              (location.pathname.includes('/creator/experience-manager') && !addParticipantList && session_type === 'REELS') &&
              <RightScoreSectionReels pathname={location.pathname} isMobile={isMobileDevice} />
            }

            {
              location.pathname.includes('/creator/dashboard') &&
              <DashboardHeaderSearchBox />
            }

            {
              location.pathname.includes('/participant/lists') && (
                <div className="searchWrapper">
                  <Grid container>
                    <Grid item md={12} sm={12} className={classes.buttonWrapper} >
                      <Button
                        color='primary'
                        className={classes.btn}
                        onClick={onCreateNewList}
                      >
                        <img src={'/assets/icons/creatordashboard/plus_icon.svg'} alt={'img'} />
                        <span className={classes.addNewBtn}>Add New List</span>
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              )
            }

            {
              (location.pathname.includes('/participant/list') && location.pathname.includes('/detail') && isEditable()) && (
                <div className="searchWrapper">
                  <Grid container>
                    <Grid item md={12} sm={12} className={classes.buttonWrapper} >
                      <Button
                        color='primary'
                        className={classes.btn}
                        onClick={onAddParticipants}
                      >
                        <img src={'/assets/icons/creatordashboard/plus_icon.svg'} alt={'img'} />
                        <span className={classes.addNewBtn}>Add Participants</span>
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              )
            }
          </>
        )}
      </Toolbar>
      {isMobileDevice && <div style={{ width: '100%', border: '1px solid #69768350' }} />}
      {
        location.pathname.includes('/creator/experience-manager') &&
        !location.pathname.includes('/creator/experience-manager/invite') && session_status &&
        <AnalyzeTopTabs isMobile={isMobileDevice} />
      }

      <ImmersionModal
        title={'Are you sure?'}
        description={'Stopping collection will complete the measurement. You cannot restart. Only do this if you are absolutely sure you want to complete the measurement.'}
        titleOK={'Yes, End Data Collection Now'}
        open={open}
        onApply={() => handleCompleteSession()}
        onClose={() => setOpen(false)}
      />

    </AppBar>
  );
}

export default TopBar;